<template>
    <div class="bloque-general bloque-video" :style="`background-image: url('/storage/`+video.imagen+`');`">
        <div class="container">
            <div class="row text-center justify-content-center">
                <div class="col-md-6">
                    <img class="bloque-video__img" src="/img/icono-play-blanco.png" alt="Video Santiango" width="85"
                        height="75" loading="lazy">
                    <h2 class="bloque-video__titulo">{{ video.titulo }}</h2>
                    <div class="bloque-video__descripcion">{{ video.texto }}</div>
                    <button @click="openVideo" class="boton-blanco boton-flecha mb-4">{{ video.boton }}</button>
                </div>
            </div>
        </div>
    </div>
    <modal-video :channel="videoChannel" :videoId="videoId" v-model:isOpen="videoIsOpen" />
</template>
<script>
import ModalVideo from '../Utils/ModalVideo.vue'
export default {
    props: {
        video: Object,
    },
    components: {
        ModalVideo
    },
    data: () => {
        return {
            videoIsOpen: false
        }
    },
    methods: {
        openVideo() {
            this.videoIsOpen = !this.videoIsOpen
        },
        closeVideo(){
            console.log("entro");
            this.videoIsOpen = false;
        }
    },
    computed: {
        videoChannel: function () {
            //Logic to extract based on URL
            return 'youtube'
        },
        videoId: function () {
            //Logic to extract based on URL
            return this.video.url;
        }
    }
}
</script>
<style>

</style>
